<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <app-user-profile-dashboard-body [favoriteItems]="favoriteItems" [languages]="languages" [countries]="countries"/>
  </app-page-template>
</ng-container>
